/* @flow */

import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import NavigationButton from 'components/NavigationButton/NavigationButton';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type UserStore from 'stores/UserStore';

export type MultilingualLanguagesProps = {
  languageCode: string,
  onChangeLanguage: (languageCode: string) => void,
};

type InjectedProps = {
  userStore: UserStore,
};

@inject('userStore')
@observer
class MultilingualLanguages extends ComponentWithInjectedProps<
  MultilingualLanguagesProps,
  {},
  InjectedProps
> {
  @observable localState = {
    anchorEl: null,
  };

  handleChangeLanguage = (languageCode: string) => {
    const { onChangeLanguage } = this.props;

    this.handleClose();
    onChangeLanguage(languageCode);
  };

  handleClick = (e: SyntheticInputEvent<EventTarget>) => {
    this.localState.anchorEl = e.currentTarget;
  };

  handleClose = () => {
    this.localState.anchorEl = null;
  };

  render() {
    const { anchorEl } = this.localState;
    const {
      languageCode,
      userStore: { userLanguages = [] },
    } = this.props;

    return (
      <React.Fragment>
        <NavigationButton onClick={this.handleClick}>
          <svg>
            <use xlinkHref="#icon-language" />
          </svg>
        </NavigationButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          getContentAnchorEl={null}
          elevation={2}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          {userLanguages &&
            userLanguages.map(item => (
              <MenuItem
                key={item.id}
                selected={item.code === languageCode}
                onClick={() => this.handleChangeLanguage(item.code)}
              >
                {item.name}
              </MenuItem>
            ))}
        </Menu>
      </React.Fragment>
    );
  }
}

export default MultilingualLanguages;
